import {OPEN_SUBSCRIBE_MODAL} from '../constants'

export const subscribedMobalOpen =(data)=>{
    return {
        type:OPEN_SUBSCRIBE_MODAL,
        data:data
    }
}